import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import MultiPicker from '../../common/controls/multiPicker';
import entityComposition from '../../common/classes/entityComposition';
const JobsFilter = ({
  jobs,
  onFilter,
  jobFilterEmployees: {
    indexQuery,
    list
  },
  jobFilterEmployeesActions: {
    serverIndex
  }
}) => {
  useEffect(() => {
    serverIndex(indexQuery);
  }, [serverIndex, indexQuery]);
  return /*#__PURE__*/React.createElement(MultiPicker, {
    labelKey: "jobNumber",
    valueKey: "id",
    label: "Jobs",
    values: jobs,
    options: list,
    onChange: value => onFilter('job', value)
  });
};
JobsFilter.propTypes = {
  jobFilterEmployeesActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobFilterEmployees: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({}),
      paging: PropTypes.shape({
        current: PropTypes.number.isRequired
      }),
      sortAttribute: PropTypes.string,
      sortDirection: PropTypes.string
    }),
    list: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.string,
      className: PropTypes.string
    }))
  }).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string
  })).isRequired,
  onFilter: PropTypes.func.isRequired
};
export { JobsFilter as TestJobsFilter };
export default entityComposition(JobsFilter, ['job', 'jobFilterEmployees']);